<p [innerHTML]="vraag.antwoord_tekst | sanitize"></p>
